/**
=========================================================
* Material Dashboard 3 PRO React - v2.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================
*/

// Material Dashboard 3 PRO React layouts
import Analytics from "layouts/dashboards/analytics";
import Umum from "layouts/dashboards/umum";
import AllApplications from "layouts/dashboards/all-applications";
import ProtectedRoute from "components/ProtectedRoute";

import ProfileOverview from "layouts/pages/profile/profile-overview";
import AllProjects from "layouts/pages/profile/all-projects";
import NewUser from "layouts/pages/users/new-user";
import Settings from "layouts/pages/account/settings";

import SignInCover from "layouts/authentication/sign-in/cover";

import DaftarTugas from "layouts/pages/tugas/daftar-tugas";
import TugasBaru from "layouts/pages/tugas/tugas-baru";
import DaftarPenugasan from "layouts/pages/tugas/daftar-penugasan";
import KinerjaTugas from "layouts/pages/tugas/kinerja-tugas";
import KinerjaTugasDetail from "layouts/pages/tugas/kinerja-tugas-detail";

import DisposisiBaru from "layouts/pages/disposisi/disposisi-baru";
import DaftarDisposisi from "layouts/pages/disposisi/daftar-disposisi";
import SuratMasuk from "layouts/pages/disposisi/surat-masuk";
import DisposisiTindakLanjut from "layouts/pages/disposisi/disposisi-TL";
import KinerjaDisposisi from "layouts/pages/disposisi/kinerja-disposisi";
import KinerjaDisposisiDetail from "layouts/pages/disposisi/kinerja-disposisi-detail";

import AsetList from "layouts/pages/aset/aset-list";
import DetailAset from "layouts/pages/aset/detail";
import ScanAset from "layouts/pages/aset/scan";
import PeminjamanAset from "layouts/pages/aset/PeminjamanAset";
import DashboardAset from "layouts/pages/aset/dashboard";

import DaftarUser from "layouts/pages/users/daftar-users";
import DaftarAllUsers from "layouts/pages/users/daftar-allusers";
import UserOverview from "layouts/pages/profile/profile-overview/user-overview";

import DaftarHadir from "layouts/pages/smartDH/daftar-hadir";
import DaftarHadirPimpinan from "layouts/pages/smartDH/daftar-hadir-pimpinan";
import KinerjaDH from "layouts/pages/smartDH/kinerja";
import DetailKinerja from "layouts/pages/smartDH/kinerja/detail";
import KinerjaPimpinanPD from "layouts/pages/smartDH/kinerja-pimpinan-pd";
import DetailKinerjaPimpinanPD from "layouts/pages/smartDH/kinerja-pimpinan-pd/detail";
import KinerjaAllDinas from "layouts/pages/smartDH/kinerja-alldinas";

import LaporanHarian from "layouts/pages/laporan-harian";
import LaporanDinas from "layouts/pages/laporan-harian/laporanDinas";
import RekapLaporanDinas from "layouts/pages/laporan-harian/rekapLaporanDinas";
import RekapanLaporanDinas from "layouts/pages/laporan-harian/rekapanLaporanDinas";
import PerorangDetail from "layouts/pages/laporan-harian/perorangDetail";
import UsersKhususLaporan from "layouts/pages/laporan-harian/usersKhususLaporan";
import UsersKhususLaporanSingleDate from "layouts/pages/laporan-harian/usersKhususLaporanSingleDate";

import ApelDinas from "layouts/pages/apel-harian/apelDinas";
import ApelSemuaDinas from "layouts/pages/apel-harian/apelSemuaDinas";
import RekapLaporanDinasApel from "layouts/pages/apel-harian/rekapLaporanDinasApel";
import PerorangDetailApel from "layouts/pages/apel-harian/perorangDetailApel";
import UsersKhususApel from "layouts/pages/apel-harian/usersKhususApel";
import UsersKhususApelSingleDate from "layouts/pages/apel-harian/usersKhususApelSingleDate";
import DetailKinerjaDinas from "layouts/pages/smartDH/kinerja-alldinas/detail-dinas";
import PerdinasDetail from "layouts/pages/laporan-harian/perdinasDetail";
import ApelDinasSuperAdmin from "layouts/pages/apel-harian/apelDinasSuperAdmin";
import DaftarLayanan from "layouts/pages/survey-kepuasan/daftar-layanan";
import DaftarResponden from "layouts/pages/survey-kepuasan/daftar-responden";

import FormSurveyPublik from "layouts/pages/survey-kepuasan/form-survey-publik";
import RekapLayanan from "layouts/pages/survey-kepuasan/rekap-layanan";

import AktivasiBukuDinas from "layouts/pages/buku-tamu/aktivasi";
import StatistikTamu from "layouts/pages/buku-tamu/statistik";
import DaftarTamu from "layouts/pages/buku-tamu/daftar-tamu";
import KinerjaInstansi from "layouts/pages/kinerja-organisasi/kinerja-instansi";
import KinerjaBidang from "layouts/pages/kinerja-organisasi/kinerja-bidang";
import DetailKinerjaBidang from "layouts/pages/kinerja-organisasi/index";
import DetailKinerjaIndividu from "layouts/pages/kinerja-organisasi/detail-individu/index";
import DaftarEvents from "layouts/pages/events/daftar-events";
import EventSaya from "layouts/pages/events/event-saya";
import LaporanEvent from "layouts/pages/events/laporan-event";
import EventYangDiikuti from "layouts/pages/events/event-yang-diikuti";
import KalenderEvent from "layouts/pages/events/kalender-event";

import DaftarDokumen from "layouts/pages/dokumen/daftar-dokumen";
import SuratMasukDokumen from "layouts/pages/dokumen/surat-masuk";
import SuratKeluarDokumen from "layouts/pages/dokumen/surat-keluar";
// Material Dashboard 3 PRO React components
import MDAvatar from "components/MDAvatar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 3 PRO React contexts
import { useMaterialUIController } from "context";

// Utils
import { API_ESA_OFFICE_UPLOAD, API_ESA_OFFICE } from "utils";
import { useNotification } from "context/NotificationContext";
import swal from "sweetalert";

// @mui icons
import Icon from "@mui/material/Icon";
import Chip from "@mui/material/Chip";

// React hooks
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Actions
import { logoutUser } from "actions/AuthAction";

// Helper function untuk melindungi component
const protectComponent = (Component) => (
  <ProtectedRoute>
    <Component />
  </ProtectedRoute>
);

// Komponen untuk label Buku Tamu dengan warna yang sesuai tema sidebar
function BukuTamuLabel() {
  const [controller] = useMaterialUIController();
  const { transparentSidenav, whiteSidenav, darkMode } = controller;

  // Tentukan warna teks berdasarkan tema sidebar (sama seperti di Sidenav)
  let textColor = "white";
  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark";
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit";
  }

  return (
    <MDBox display="flex" alignItems="center">
      <MDTypography
        variant="button"
        color={textColor}
        fontWeight="light"
        sx={{
          fontSize: "0.75rem",
          lineHeight: 1,
          fontWeight: 300, // fontWeightLight sesuai dengan menu lain
        }}
      >
        Buku Tamu
      </MDTypography>
      <BukuTamuBadge />
    </MDBox>
  );
}

// Komponen untuk label DOKUMEN dengan badge jumlah dokumen
function DokumenLabel() {
  const [controller] = useMaterialUIController();
  const { transparentSidenav, whiteSidenav, darkMode } = controller;

  // Tentukan warna teks berdasarkan tema sidebar (sama seperti di Sidenav)
  let textColor = "white";
  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark";
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit";
  }

  return (
    <MDBox display="flex" alignItems="center">
      <MDTypography
        variant="button"
        color={textColor}
        fontWeight="light"
        sx={{
          fontSize: "0.75rem",
          lineHeight: 1,
          fontWeight: 300, // fontWeightLight sesuai dengan menu lain
        }}
      >
        DOKUMEN
      </MDTypography>
      <DokumenCountBadge />
    </MDBox>
  );
}

// Komponen untuk badge status buku dinas
function BukuTamuBadge() {
  const [isAktif, setIsAktif] = useState(false);
  const [loading, setLoading] = useState(true);

  const checkBukuDinas = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user && user.dinas_id) {
        const response = await fetch(
          `${API_ESA_OFFICE}buku-tamu/buku-dinas/${user.dinas_id}`
        );
        if (response.ok) {
          const data = await response.json();
          setIsAktif(data !== null && data !== undefined);
        } else {
          setIsAktif(false);
        }
      }
    } catch (error) {
      console.error("Error checking buku dinas:", error);
      setIsAktif(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkBukuDinas();

    // Listen untuk custom event dari halaman aktivasi
    const handleBukuDinasUpdated = (event) => {
      if (event.detail) {
        setIsAktif(true);
      }
    };

    window.addEventListener("bukuDinasUpdated", handleBukuDinasUpdated);

    return () => {
      window.removeEventListener("bukuDinasUpdated", handleBukuDinasUpdated);
    };
  }, []);

  if (loading) return null;

  return (
    <MDBox
      component="span"
      sx={{
        ml: 1,
        display: "inline-flex",
        alignItems: "center",
        height: "18px",
        padding: "0 6px",
        borderRadius: "9px",
        fontSize: "0.65rem",
        fontWeight: 500,
        backgroundColor: isAktif ? "#4caf50" : "#ff9800",
        color: "#ffffff",
        whiteSpace: "nowrap",
        lineHeight: 1,
      }}
    >
      {isAktif ? "Aktif" : "Belum Aktif"}
    </MDBox>
  );
}

// Komponen Badge untuk Jumlah Dokumen
function DokumenCountBadge() {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchDokumenCount = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      console.log("DokumenCountBadge - User from localStorage:", user);

      if (user && user.dinas_id) {
        const url = `${API_ESA_OFFICE}dokumen/count/${user.dinas_id}`;

        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          // Backend mengirim count sebagai string
          const countText = await response.text();
          const count = parseInt(countText) || 0;
          setCount(count);
        } else {
          const errorText = await response.text();
          console.error(
            "DokumenCountBadge - Response not OK:",
            response.status,
            response.statusText,
            errorText
          );
          setCount(0);
        }
      } else {
        setCount(0);
      }
    } catch (error) {
      setCount(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDokumenCount();

    // Listen untuk custom event ketika dokumen ditambah/dihapus/diupdate
    const handleDokumenUpdated = (event) => {
      if (event.detail) {
        fetchDokumenCount();
      }
    };

    window.addEventListener("dokumenUpdated", handleDokumenUpdated);

    return () => {
      window.removeEventListener("dokumenUpdated", handleDokumenUpdated);
    };
  }, []);

  // Sama seperti BukuTamuBadge: return null saat loading
  if (loading) return null;

  // Badge selalu tampil meskipun count = 0
  return (
    <MDBox
      component="span"
      sx={{
        ml: 1,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "18px",
        height: "18px",
        padding: "0 6px",
        borderRadius: "9px",
        fontSize: "0.65rem",
        fontWeight: 500,
        backgroundColor: "#ff9800", // Warning color
        color: "#ffffff",
        whiteSpace: "nowrap",
        lineHeight: 1,
      }}
    >
      {count > 99 ? "99+" : count}
    </MDBox>
  );
}

// Komponen Badge untuk Instruksi Baru (untuk penerima)
function InstruksiBaruBadge() {
  const { notifications, loading } = useNotification();
  const count = notifications.instruksi.instruksi_baru || 0;

  if (loading || count === 0) return null;

  return (
    <MDBox
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "16px",
        height: "16px",
        padding: "0 4px",
        borderRadius: "8px",
        fontSize: "0.6rem",
        fontWeight: 600,
        backgroundColor: "#f44336", // Merah untuk semua badge
        color: "#ffffff", // Putih untuk label - selalu putih
        "& *": {
          color: "#ffffff !important", // Memastikan semua child element juga putih
        },
        whiteSpace: "nowrap",
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      <MDTypography
        component="span"
        sx={{
          color: "#ffffff !important",
          WebkitTextFillColor: "#ffffff",
          fontSize: "inherit",
          fontWeight: "inherit",
          lineHeight: "inherit",
        }}
      >
        {count > 99 ? "99+" : count}
      </MDTypography>
    </MDBox>
  );
}

// Komponen Badge untuk Instruksi Selesai Belum Respon (untuk pemberi)
function InstruksiSelesaiBadge() {
  const { notifications, loading } = useNotification();
  const count = notifications.instruksi.instruksi_selesai_belum_respon || 0;

  if (loading || count === 0) return null;

  return (
    <MDBox
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "16px",
        height: "16px",
        padding: "0 4px",
        borderRadius: "8px",
        fontSize: "0.6rem",
        fontWeight: 600,
        backgroundColor: "#f44336", // Merah untuk semua badge
        color: "#ffffff", // Putih untuk label - selalu putih
        "& *": {
          color: "#ffffff !important", // Memastikan semua child element juga putih
        },
        whiteSpace: "nowrap",
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      <MDTypography
        component="span"
        sx={{
          color: "#ffffff !important",
          WebkitTextFillColor: "#ffffff",
          fontSize: "inherit",
          fontWeight: "inherit",
          lineHeight: "inherit",
        }}
      >
        {count > 99 ? "99+" : count}
      </MDTypography>
    </MDBox>
  );
}

// Komponen Badge untuk Akumulasi Instruksi (Instruksi Baru + Instruksi Selesai Belum Respon)
function InstruksiTotalBadge() {
  const { notifications, loading } = useNotification();
  const countBaru = notifications.instruksi.instruksi_baru || 0;
  const countSelesai =
    notifications.instruksi.instruksi_selesai_belum_respon || 0;
  const totalCount = countBaru + countSelesai;

  if (loading || totalCount === 0) return null;

  return (
    <MDBox
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "16px",
        height: "16px",
        padding: "0 4px",
        borderRadius: "8px",
        fontSize: "0.6rem",
        fontWeight: 600,
        backgroundColor: "#f44336", // Merah untuk semua badge
        color: "#ffffff", // Putih untuk label - selalu putih
        "& *": {
          color: "#ffffff !important", // Memastikan semua child element juga putih
        },
        whiteSpace: "nowrap",
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      <MDTypography
        component="span"
        sx={{
          color: "#ffffff !important",
          WebkitTextFillColor: "#ffffff",
          fontSize: "inherit",
          fontWeight: "inherit",
          lineHeight: "inherit",
        }}
      >
        {totalCount > 99 ? "99+" : totalCount}
      </MDTypography>
    </MDBox>
  );
}

// Komponen Badge untuk Surat Masuk Belum Disposisi
function SuratMasukBelumDisposisiBadge() {
  const { notifications, loading } = useNotification();
  const count = notifications.disposisi.surat_masuk_belum_disposisi || 0;

  if (loading || count === 0) return null;

  return (
    <MDBox
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "16px",
        height: "16px",
        padding: "0 4px",
        borderRadius: "8px",
        fontSize: "0.6rem",
        fontWeight: 600,
        backgroundColor: "#f44336", // Merah untuk semua badge
        color: "#ffffff", // Putih untuk label - selalu putih
        "& *": {
          color: "#ffffff !important", // Memastikan semua child element juga putih
        },
        whiteSpace: "nowrap",
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      <MDTypography
        component="span"
        sx={{
          color: "#ffffff !important",
          WebkitTextFillColor: "#ffffff",
          fontSize: "inherit",
          fontWeight: "inherit",
          lineHeight: "inherit",
        }}
      >
        {count > 99 ? "99+" : count}
      </MDTypography>
    </MDBox>
  );
}

// Komponen Badge untuk Disposisi Baru
function DisposisiBaruBadge() {
  const { notifications, loading } = useNotification();
  const count = notifications.disposisi.disposisi_baru || 0;

  if (loading || count === 0) return null;

  return (
    <MDBox
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "16px",
        height: "16px",
        padding: "0 4px",
        borderRadius: "8px",
        fontSize: "0.6rem",
        fontWeight: 600,
        backgroundColor: "#f44336", // Merah untuk semua badge
        color: "#ffffff", // Putih untuk label - selalu putih
        "& *": {
          color: "#ffffff !important", // Memastikan semua child element juga putih
        },
        whiteSpace: "nowrap",
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      <MDTypography
        component="span"
        sx={{
          color: "#ffffff !important",
          WebkitTextFillColor: "#ffffff",
          fontSize: "inherit",
          fontWeight: "inherit",
          lineHeight: "inherit",
        }}
      >
        {count > 99 ? "99+" : count}
      </MDTypography>
    </MDBox>
  );
}

// Komponen Badge untuk Disposisi Selesai Belum Respon
function DisposisiSelesaiBadge() {
  const { notifications, loading } = useNotification();
  const count = notifications.disposisi.disposisi_selesai_belum_respon || 0;

  if (loading || count === 0) return null;

  return (
    <MDBox
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "16px",
        height: "16px",
        padding: "0 4px",
        borderRadius: "8px",
        fontSize: "0.6rem",
        fontWeight: 600,
        backgroundColor: "#f44336", // Merah untuk semua badge
        color: "#ffffff", // Putih untuk label - selalu putih
        "& *": {
          color: "#ffffff !important", // Memastikan semua child element juga putih
        },
        whiteSpace: "nowrap",
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      <MDTypography
        component="span"
        sx={{
          color: "#ffffff !important",
          WebkitTextFillColor: "#ffffff",
          fontSize: "inherit",
          fontWeight: "inherit",
          lineHeight: "inherit",
        }}
      >
        {count > 99 ? "99+" : count}
      </MDTypography>
    </MDBox>
  );
}

// Komponen Badge Total untuk Disposisi (akumulasi: surat masuk + daftar disposisi + disposisi tindak lanjut)
function DisposisiTotalBadge() {
  const { notifications, loading } = useNotification();
  const countSuratMasuk =
    notifications.disposisi.surat_masuk_belum_disposisi || 0;
  const countDisposisiBaru = notifications.disposisi.disposisi_baru || 0;
  const countDisposisiSelesai =
    notifications.disposisi.disposisi_selesai_belum_respon || 0;
  const totalCount =
    countSuratMasuk + countDisposisiBaru + countDisposisiSelesai;

  if (loading || totalCount === 0) return null;

  return (
    <MDBox
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "16px",
        height: "16px",
        padding: "0 4px",
        borderRadius: "8px",
        fontSize: "0.6rem",
        fontWeight: 600,
        backgroundColor: "#f44336", // Merah untuk semua badge
        color: "#ffffff", // Putih untuk label - selalu putih
        "& *": {
          color: "#ffffff !important", // Memastikan semua child element juga putih
        },
        whiteSpace: "nowrap",
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      <MDTypography
        component="span"
        sx={{
          color: "#ffffff !important",
          WebkitTextFillColor: "#ffffff",
          fontSize: "inherit",
          fontWeight: "inherit",
          lineHeight: "inherit",
        }}
      >
        {totalCount > 99 ? "99+" : totalCount}
      </MDTypography>
    </MDBox>
  );
}

// Komponen Badge Total untuk Manajemen Tugas (akumulasi: total instruksi + total disposisi)
function ManajemenTugasTotalBadge() {
  const { notifications, loading } = useNotification();
  const totalInstruksi =
    (notifications.instruksi.instruksi_baru || 0) +
    (notifications.instruksi.instruksi_selesai_belum_respon || 0);
  const totalDisposisi =
    (notifications.disposisi.surat_masuk_belum_disposisi || 0) +
    (notifications.disposisi.disposisi_baru || 0) +
    (notifications.disposisi.disposisi_selesai_belum_respon || 0);
  const totalCount = totalInstruksi + totalDisposisi;

  if (loading || totalCount === 0) return null;

  return (
    <MDBox
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "16px",
        height: "16px",
        padding: "0 4px",
        borderRadius: "8px",
        fontSize: "0.6rem",
        fontWeight: 600,
        backgroundColor: "#f44336", // Merah untuk semua badge
        color: "#ffffff", // Putih untuk label - selalu putih
        "& *": {
          color: "#ffffff !important", // Memastikan semua child element juga putih
        },
        whiteSpace: "nowrap",
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      <MDTypography
        component="span"
        sx={{
          color: "#ffffff !important",
          WebkitTextFillColor: "#ffffff",
          fontSize: "inherit",
          fontWeight: "inherit",
          lineHeight: "inherit",
        }}
      >
        {totalCount > 99 ? "99+" : totalCount}
      </MDTypography>
    </MDBox>
  );
}

// Fungsi untuk mengambil data user dari localStorage secara dinamis
const getUserData = () => {
  try {
    const userStorage = localStorage.getItem("user");
    if (userStorage) {
      const user = JSON.parse(userStorage);

      return {
        userName: user.nama ? user.nama.split(" ")[0] : "User",
        userProfile: user.uid
          ? `https://smartdh.rotendaokab.go.id/uploads/${user.uid_RSS}.jpg`
          : undefined,
        status: user.status || undefined,
      };
    }
  } catch (error) {
    console.error("Error parsing user data:", error);
  }
  return {
    userName: "User",
    userProfile: undefined,
    status: undefined,
  };
};

// Komponen Logout dengan konfirmasi (route khusus /logout)
function LogoutComponent() {
  const navigate = useNavigate();

  logoutUser(navigate);
}

// Komponen UserProfile yang dinamis dengan React hooks
function UserProfile() {
  const [userData, setUserData] = useState(() => getUserData());

  useEffect(() => {
    const handleStorageChange = () => {
      setUserData(getUserData());
    };

    window.addEventListener("storage", handleStorageChange);

    const interval = setInterval(() => {
      const currentData = getUserData();
      if (JSON.stringify(currentData) !== JSON.stringify(userData)) {
        setUserData(currentData);
      }
    }, 1000);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, [userData]);

  return (
    <MDAvatar
      src={userData.userProfile ? userData.userProfile : undefined}
      alt={userData.userName}
      size="sm"
    />
  );
}

// Komponen untuk nama user yang dinamis
function UserName() {
  const [userName, setUserName] = useState(() => getUserData().userName);

  useEffect(() => {
    const handleStorageChange = () => {
      setUserName(getUserData().userName);
    };

    window.addEventListener("storage", handleStorageChange);

    const interval = setInterval(() => {
      const currentUserName = getUserData().userName;
      if (currentUserName !== userName) {
        setUserName(currentUserName);
      }
    }, 1000);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, [userName]);

  return userName;
}

const routes = [
  {
    type: "collapse",
    name: <UserName />,
    key: "brooklyn-alice",
    available: true,
    icon: <UserProfile />,
    collapse: [
      {
        name: "My Profile",
        key: "my-profile",
        route: "/pages/profile/profile-overview",
        component: protectComponent(ProfileOverview),
        available: true,
      },
      {
        name: "Logout",
        key: "logout",
        route: "/logout",
        component: <LogoutComponent />,
        available: true,
      },
    ],
  },
  { type: "divider", key: "divider-0", available: true },
  {
    type: "collapse",
    name: "Dashboards",
    key: "dashboards",
    icon: <Icon fontSize="small">dashboard</Icon>,
    available: true,
    collapse: [
      {
        name: "Analytics",
        key: "analytics",
        route: "/dashboards/analytics",
        component: protectComponent(Analytics),
        available: true,
      },
      {
        name: "Aplikasi Terintegrasi",
        key: "aplikasi-terintegrasi",
        route: "/dashboards/aplikasi-terintegrasi",
        component: protectComponent(AllApplications),
        available: true,
      },
      {
        name: "Berita Terkini",
        key: "berita-terkini",
        route: "/dashboards/berita-terkini",
        component: protectComponent(Umum),
        available: true,
      },
    ],
  },
  { type: "title", title: "Menu", key: "title-pages", available: true },
  {
    type: "collapse",
    name: "Manajemen Tugas",
    key: "task-management",
    icon: <Icon fontSize="small">task_alt</Icon>,
    badge: <ManajemenTugasTotalBadge />,
    allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
    collapse: [
      {
        name: "Tugas",
        key: "tugas",
        route: "/task-management/tugas/instruksi-baru",
        icon: <Icon fontSize="small">task</Icon>,
        badge: <InstruksiTotalBadge />,
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
        collapse: [
          {
            name: "Instruksi Baru",
            key: "instruksi-baru",
            route: "/task-management/tugas/instruksi-baru",
            component: protectComponent(TugasBaru),
            allowedStatuses: ["admin", "super admin", "pimpinan", "user"],
          },
          {
            name: "Daftar Instruksi",
            key: "daftar-instruksi",
            route: "/task-management/tugas/daftar-instruksi",
            component: protectComponent(DaftarTugas),
            badge: <InstruksiSelesaiBadge />,
            allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
          },
          {
            name: "Daftar Tugas",
            key: "daftar-tugas",
            route: "/task-management/tugas/daftar-tugas",
            component: protectComponent(DaftarPenugasan),
            badge: <InstruksiBaruBadge />,
            allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
          },
          {
            name: "Kinerja Tugas",
            key: "kinerja-tugas",
            route: "/task-management/tugas/kinerja-tugas",
            component: protectComponent(KinerjaTugas),
            allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
          },
        ],
      },
      {
        name: "Disposisi",
        key: "disposisi",
        route: "/task-management/disposisi/surat-masuk",
        icon: <Icon fontSize="small">mail</Icon>,
        badge: <DisposisiTotalBadge />,
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
        collapse: [
          {
            type: "item",
            name: "Surat Masuk",
            key: "surat-masuk",
            route: "/task-management/disposisi/surat-masuk",
            component: protectComponent(SuratMasuk),
            badge: <SuratMasukBelumDisposisiBadge />,
            allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
          },
          {
            type: "item",
            name: "Disposisi Baru",
            key: "disposisi-baru",
            route: "/task-management/disposisi/disposisi-baru",
            component: protectComponent(DisposisiBaru),
            allowedStatuses: ["admin", "super admin", "pimpinan", "user"],
            allowedLevelJabatan: [1, 2], // Hanya level_jabatan 1 atau 2
          },
          {
            type: "item",
            name: "Daftar Disposisi",
            key: "daftar-disposisi",
            route: "/task-management/disposisi/daftar-disposisi",
            component: protectComponent(DaftarDisposisi),
            badge: <DisposisiSelesaiBadge />,
            allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
            allowedLevelJabatan: [1, 2], // Hanya level_jabatan 1 atau 2
          },
          {
            type: "item",
            name: "Disposisi TL",
            key: "disposisi-tindak-lanjut",
            route: "/task-management/disposisi/disposisi-TL",
            component: protectComponent(DisposisiTindakLanjut),
            badge: <DisposisiBaruBadge />,
            allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
          },
          {
            type: "item",
            name: "Kinerja Disposisi",
            key: "kinerja-disposisi",
            route: "/task-management/disposisi/kinerja-disposisi",
            component: protectComponent(KinerjaDisposisi),
            allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
          },
        ],
      },
    ],
  },
  {
    type: "collapse",
    name: "Kinerja Harian",
    key: "daily-performance",
    icon: <Icon fontSize="small">assessment</Icon>,
    allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
    collapse: [
      {
        name: "Smart DH",
        key: "smart-dh",
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
        collapse: [
          {
            name: "Daftar Hadir",
            key: "daftar-hadir",
            route: "/daily-performance/smartDH/daftar-hadir",
            component: protectComponent(DaftarHadir),
            allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
          },
          {
            name: "Daftar Hadir Pimpinan",
            key: "daftar-hadir-pimpinan",
            route: "/daily-performance/smartDH/daftar-hadir-pimpinan",
            component: protectComponent(DaftarHadirPimpinan),
            allowedStatuses: ["super admin", "pimpinan"],
          },

          {
            name: "Kinerja Instansi",
            key: "kinerja-instansi",
            route: "/daily-performance/smartDH/kinerja-instansi",
            component: protectComponent(KinerjaDH),
            allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
          },
          {
            name: "Kinerja Pimpinan PD",
            key: "kinerja-pimpinan-pd",
            route: "/daily-performance/smartDH/kinerja-pimpinan-pd",
            component: protectComponent(KinerjaPimpinanPD),
            allowedStatuses: ["super admin", "pimpinan"],
          },
          {
            name: "Kinerja All Dinas",
            key: "kinerja-alldinas",
            route: "/daily-performance/smartDH/kinerja-alldinas",
            component: protectComponent(KinerjaAllDinas),
            allowedStatuses: ["pimpinan", "super admin"],
          },
        ],
      },
      {
        name: "Laporan Harian",
        key: "laporan-harian",
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
        icon: <Icon fontSize="small">assignment</Icon>,
        collapse: [
          {
            name: "Lapor Per-Orang",
            key: "per-orang",
            route: "/daily-performance/laporan-harian/per-orang",
            component: protectComponent(LaporanHarian),
            allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
          },
          {
            name: "Lapor Per-Dinas",
            key: "per-dinas",
            route: "/daily-performance/laporan-harian/per-dinas",
            component: protectComponent(LaporanDinas),
            allowedStatuses: ["admin", "super admin", "user"],
          },
          {
            name: "Rekapan Dinas",
            key: "rekap-dinas",
            route: "/daily-performance/laporan-harian/rekap-dinas",
            component: protectComponent(RekapLaporanDinas),
            allowedStatuses: ["admin", "super admin", "user"],
          },
          {
            name: "Rekapan All Dinas",
            key: "rekapan-semua-dinas",
            route: "/daily-performance/laporan-harian/rekapan-semua-dinas",
            component: protectComponent(RekapanLaporanDinas),
            allowedStatuses: ["super admin", "pimpinan"],
          },
          {
            name: "Laporan Pimpinan",
            key: "users-khusus-laporan-single",
            route: "/daily-performance/laporan-harian/laporan-pimpinan",
            component: protectComponent(UsersKhususLaporanSingleDate),
            allowedStatuses: ["super admin", "pimpinan"],
          },
          {
            name: "Rekapan Pimpinan",
            key: "users-khusus-laporan",
            route: "/daily-performance/laporan-harian/rekapan-pimpinan",
            component: protectComponent(UsersKhususLaporan),
            allowedStatuses: ["super admin", "pimpinan"],
          },
        ],
      },
      {
        name: "Apel Harian",
        key: "apel-harian",
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
        icon: <Icon fontSize="small">schedule</Icon>,
        collapse: [
          {
            name: "Daftar Apel",
            key: "apel-per-dinas",
            route: "/daily-performance/apel-harian/daftar-apel",
            component: protectComponent(ApelDinas),
            allowedStatuses: ["admin", "super admin", "user"],
          },
          {
            name: "Rekapan Dinas",
            key: "apel-rekap-dinas",
            route: "/daily-performance/apel-harian/rekapan-dinas",
            component: protectComponent(RekapLaporanDinasApel),
            allowedStatuses: ["admin", "super admin", "user"],
          },
          {
            name: "Rekap All Dinas",
            key: "apel-semua-dinas",
            route: "/daily-performance/apel-harian/semua-dinas",
            component: protectComponent(ApelSemuaDinas),
            allowedStatuses: ["super admin", "pimpinan"],
          },
          {
            name: "Daftar Apel Pimpinan",
            key: "users-khusus-apel-single",
            route: "/daily-performance/apel-harian/users-khusus-apel-single",
            component: protectComponent(UsersKhususApelSingleDate),
            allowedStatuses: ["super admin", "pimpinan"],
          },
          {
            name: "Rekapan Pimpinan",
            key: "users-khusus-apel",
            route: "/daily-performance/apel-harian/rekapan-pimpinan",
            component: protectComponent(UsersKhususApel),
            allowedStatuses: ["super admin", "pimpinan"],
          },
        ],
      },
    ],
  },
  {
    type: "collapse",
    name: "Manajemen Resource",
    key: "resource",
    icon: <Icon fontSize="small">settings_applications</Icon>,
    available: true,
    collapse: [
      {
        name: "E - Aset Malole",
        key: "aset",
        available: true,
        route: "/resource/aset/dashboard",
        icon: <Icon fontSize="small">inventory</Icon>,
        collapse: [
          {
            name: "Dashboard Aset",
            key: "dashboard-aset",
            route: "/resource/aset/dashboard",
            component: protectComponent(DashboardAset),
            allowedStatuses: ["admin", "super admin", "user"],
          },
          {
            name: "Daftar Aset",
            key: "daftar-aset",
            route: "/resource/aset/daftar-aset",
            component: protectComponent(AsetList),
            allowedStatuses: ["admin", "super admin", "user"],
          },
          {
            name: "Scan QR Code",
            key: "scan-aset",
            route: "/resource/aset/scan",
            component: protectComponent(ScanAset),
            allowedStatuses: ["admin", "super admin", "user"],
          },
          {
            name: "Peminjaman Aset",
            key: "peminjaman-aset",
            route: "/resource/aset/peminjaman-aset",
            component: protectComponent(PeminjamanAset),
            allowedStatuses: ["admin", "super admin", "user"],
          },
        ],
      },
    ],
  },
  {
    type: "collapse",
    name: "Layanan Publik",
    key: "layanan-publik",
    icon: <Icon fontSize="small">public</Icon>,
    allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
    collapse: [
      {
        type: "item",
        name: "Daftar Layanan",
        key: "daftar-layanan",
        route: "/layanan-publik/daftar-layanan",
        component: protectComponent(DaftarLayanan),
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
      },
      {
        type: "item",
        name: "Daftar Responden",
        key: "daftar-responden",
        route: "/layanan-publik/daftar-responden",
        component: protectComponent(DaftarResponden),
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
      },

      {
        type: "item",
        name: "Rekap Layanan",
        key: "rekap-layanan",
        route: "/layanan-publik/rekap-layanan",
        component: protectComponent(RekapLayanan),
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
      },
    ],
  },
  {
    type: "collapse",
    name: <BukuTamuLabel />,
    key: "buku-tamu",
    icon: <Icon fontSize="small">book</Icon>,
    allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
    collapse: [
      {
        type: "item",
        name: "Aktivasi Buku Dinas",
        key: "aktivasi-buku-dinas",
        route: "/buku-tamu/aktivasi",
        component: protectComponent(AktivasiBukuDinas),
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
      },
      {
        type: "item",
        name: "Statistik Tamu",
        key: "statistik-tamu",
        route: "/buku-tamu/statistik",
        component: protectComponent(StatistikTamu),
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
      },
      {
        type: "item",
        name: "Daftar Tamu",
        key: "daftar-tamu",
        route: "/buku-tamu/daftar-tamu",
        component: protectComponent(DaftarTamu),
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
      },
    ],
  },
  {
    type: "collapse",
    name: "Events",
    key: "events",
    icon: <Icon fontSize="small">event</Icon>,
    allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
    collapse: [
      {
        type: "item",
        name: "Daftar Events",
        key: "daftar-events",
        route: "/events/daftar-events",
        component: protectComponent(DaftarEvents),
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
      },
      {
        type: "item",
        name: "Event Saya",
        key: "event-saya",
        route: "/events/event-saya",
        component: protectComponent(EventSaya),
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
      },
      {
        type: "item",
        name: "Laporan Event",
        key: "laporan-event",
        route: "/events/laporan-event",
        component: protectComponent(LaporanEvent),
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
      },
      {
        type: "item",
        name: "Event yang Diikuti",
        key: "event-yang-diikuti",
        route: "/events/event-yang-diikuti",
        component: protectComponent(EventYangDiikuti),
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
      },
      {
        type: "item",
        name: "Kalender",
        key: "kalender-event",
        route: "/events/kalender-event",
        component: protectComponent(KalenderEvent),
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
      },
    ],
  },
  {
    type: "collapse",
    name: <DokumenLabel />,
    key: "dokumen",
    icon: <Icon fontSize="small">description</Icon>,
    allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
    collapse: [
      {
        type: "item",
        name: "Daftar Dokumen",
        key: "daftar-dokumen",
        route: "/dokumen/daftar-dokumen",
        component: protectComponent(DaftarDokumen),
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
      },
      {
        type: "item",
        name: "Surat Masuk",
        key: "surat-masuk",
        route: "/dokumen/surat-masuk",
        component: protectComponent(SuratMasukDokumen),
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
      },
      {
        type: "item",
        name: "Surat Keluar",
        key: "surat-keluar",
        route: "/dokumen/surat-keluar",
        component: protectComponent(SuratKeluarDokumen),
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
      },
    ],
  },
  {
    type: "collapse",
    name: "Kinerja Organisasi",
    key: "kinerja-organisasi",
    icon: <Icon fontSize="small">business</Icon>,
    allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
    collapse: [
      {
        type: "item",
        name: "Kinerja Instansi",
        key: "kinerja-instansi",
        route: "/kinerja-organisasi/kinerja-instansi",
        component: protectComponent(KinerjaInstansi),
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
      },
      {
        type: "item",
        name: "Kinerja Bidang",
        key: "kinerja-bidang",
        route: "/kinerja-organisasi/kinerja-bidang",
        component: protectComponent(KinerjaBidang),
        allowedStatuses: ["admin", "super admin", "user", "pimpinan"],
      },
    ],
  },

  {
    type: "collapse",
    name: "Team",
    key: "team",
    icon: <Icon fontSize="small">people</Icon>,
    available: true,
    collapse: [
      {
        name: "User baru",
        key: "new-user",
        route: "/team/new-user",
        component: protectComponent(NewUser),
        allowedStatuses: ["admin", "super admin"],
      },
      {
        name: "Daftar User",
        key: "daftar-user",
        route: "/team/daftar-user",
        component: protectComponent(DaftarUser),
        allowedStatuses: ["pimpinan", "super admin", "user", "admin"],
      },
      {
        name: "Daftar Semua Users",
        key: "daftar-all-users",
        route: "/team/daftar-all-users",
        component: protectComponent(DaftarAllUsers),
        allowedStatuses: ["pimpinan", "super admin"],
      },
      {
        name: "Profile Overview",
        key: "profile-overview",
        route: "/team/profile-overview",
        component: protectComponent(ProfileOverview),
        allowedStatuses: ["pimpinan", "super admin", "user", "admin"],
      },
    ],
  },
];

// Export khusus untuk route detail
export const signInCoverRoute = {
  route: "/authentication/sign-in/cover",
  component: <SignInCover />,
};

export const formSurveyPublikRoute = {
  route: "/publik/survey-kepuasan/:id",
  component: FormSurveyPublik,
};

export const detailAsetRoute = {
  route: "pages/aset/detail/:id",
  component: protectComponent(DetailAset),
};

export const userOverviewRoute = {
  route: "pages/profile/user-overview/:id",
  component: protectComponent(UserOverview),
};

export const detailKinerjaRoute = {
  route: "pages/smartDH/kinerja/detail/:uid",
  component: protectComponent(DetailKinerja),
};

export const kinerjaPimpinanPDDetailRoute = {
  route: "pages/smartDH/kinerja-pimpinan-pd/detail/:uid",
  component: protectComponent(DetailKinerjaPimpinanPD),
};

export const detailKinerjaDinasRoute = {
  route: "pages/smartDH/kinerja-alldinas/detail/:id",
  component: protectComponent(DetailKinerjaDinas),
};

export const perorangDetailRoute = {
  route: "daily-performance/laporan-harian/perorang-detail/:uid_RSS",
  component: protectComponent(PerorangDetail),
};

export const perorangDetailApelRoute = {
  route: "pages/apel-harian/perorang-detail/:uid_RSS",
  component: protectComponent(PerorangDetailApel),
};

export const apelDinasSuperAdminRoute = {
  route: "/pages/apel-harian/apel-dinas-superadmin",
  component: protectComponent(ApelDinasSuperAdmin),
};

export const perdinasDetailLaporanRoute = {
  route: "/daily-performance/laporan-harian/perdinas-detail/:dinasId",
  component: protectComponent(PerdinasDetail),
};

export const kinerjaDisposisiDetailRoute = {
  route: "/task-management/disposisi/kinerja-disposisi-detail/:penerimaId",
  component: protectComponent(KinerjaDisposisiDetail),
};

export const kinerjaTugasDetailRoute = {
  route: "/task-management/tugas/kinerja-tugas-detail/:penerimaId",
  component: protectComponent(KinerjaTugasDetail),
};

export const detailKinerjaIndividuRoute = {
  route: "/kinerja-organisasi/bidang/:bidangId/individu/:uid_RSS/detail",
  component: protectComponent(DetailKinerjaIndividu),
};

export default routes;
